import { render, staticRenderFns } from "./TableWithDesc.vue?vue&type=template&id=8aec82c0&scoped=true&"
import script from "./TableWithDesc.vue?vue&type=script&lang=js&"
export * from "./TableWithDesc.vue?vue&type=script&lang=js&"
import style0 from "./TableWithDesc.vue?vue&type=style&index=0&id=8aec82c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aec82c0",
  null
  
)

export default component.exports